import { useCallback } from "react";
import type { ReactNode } from "react";
import { Button, Grid } from "@mui/material";
import { useSnackbarErrorHandler } from "utils/errorHandling";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { etatPrefectureService } from "services";
import type { EtatPrefectureType } from "constants/EtatPrefecture";

interface IEtatPrefectureButtonProps {
  libelle: string;
  type: EtatPrefectureType;
}
function EtatPrefectureButton({ libelle, type }: Readonly<IEtatPrefectureButtonProps>): ReactNode {
  const { catchErrors, isLoading } = useSnackbarErrorHandler();

  const generateFile = useCallback(() => {
    async function generateAndDownloadFile(): Promise<Blob> {
      return etatPrefectureService.generateFichierEtatPrefecture(type);
    }
    void catchErrors(generateAndDownloadFile);
  }, [type, catchErrors]);

  return (
    <Grid>
      <Button
        size="small"
        onClick={generateFile}
        loading={isLoading}
        variant="text"
        color="inherit"
        loadingPosition="start"
        startIcon={<FileDownloadIcon />}>
        {libelle}
      </Button>
    </Grid>
  );
}

export default EtatPrefectureButton;
